import React, { lazy } from 'react';
const TOMO_1_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779243949/hf_20260520_021954_4920d429-b0ec-47b0-9fe4-5fd9ce48201a_sfpswv.webp';
const TOMO_2_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779243952/hf_20260520_022102_8bfe0a68-145c-49b8-beb5-f8d8f61325da_1_fde4es.webp';
const TOMO_3_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779244027/hf_20260520_022225_e1ac0a31-6e8d-4664-a0f9-16dadf409931_mq5qnw.webp';
const TOMO_4_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779244028/hf_20260520_022232_fdf88aef-6e13-4959-9910-8e6b1e0a054b_1_ksidio.webp';
const TOMO_5_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779244054/hf_20260520_022237_df5cd790-83fb-481e-a211-8889c1c0ad29_vqzogv.webp';
const TOMO_6_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779244057/hf_20260520_022241_33307329-4a75-484a-834d-d6c5792856f9_omwyjf.webp';
const tomes = [{
  number: '01',
  title: 'Método de Estudio y Organización de la Carrera',
  desc: 'Active Recall, Spaced Repetition, Anki, técnica Feynman y cómo planificar toda la carrera desde primer año.',
  emoji: '🧠',
  image: TOMO_1_IMG
}, {
  number: '02',
  title: 'Anatomía Filtrada — Lo que sí entra',
  desc: 'Miembro superior, inferior, tórax, abdomen, cabeza y cuello. Solo los 50 temas que siempre preguntan, con mnemotecnias.',
  emoji: '🦴',
  image: TOMO_2_IMG
}, {
  number: '03',
  title: 'Fisiología de Supervivencia',
  desc: 'Cardiovascular, respiratorio, renal, nervioso, endócrino y digestivo. Con las preguntas más frecuentes de final.',
  emoji: '❤️',
  image: TOMO_3_IMG
}, {
  number: '04',
  title: 'Farmacología — El Repaso Definitivo',
  desc: 'Farmacocinética, farmacodinamia, SNA, antibióticos, cardiovascular, embarazo, insuficiencia renal y analgésicos.',
  emoji: '💊',
  image: TOMO_4_IMG
}, {
  number: '05',
  title: 'Introducción a la Clínica',
  desc: 'Historia clínica, semiología, signos vitales, razonamiento clínico, síndromes frecuentes y urgencias: RCP, shock, ACV.',
  emoji: '🩺',
  image: TOMO_5_IMG
}, {
  number: '06',
  title: 'Organización de la Carrera Completa',
  desc: 'Mapa de la carrera, cómo elegir cátedras, salud mental, sistema de residencias y orientación vocacional.',
  emoji: '🎓',
  image: TOMO_6_IMG
}];
const bonuses = [{
  emoji: '📅',
  title: 'Plan de Estudio Semana a Semana'
}, {
  emoji: '🃏',
  title: 'Fichas de Memoria Imprimibles'
}, {
  emoji: '📱',
  title: 'Guía de Recursos Digitales'
}, {
  emoji: '✅',
  title: 'Checklist de Parcial y Final'
}, {
  emoji: '🧠',
  title: 'Mnemotecnia Médica Completa'
}, {
  emoji: '📋',
  title: 'Plantilla de Organización y Tracker'
}];
export function WhatYouGet() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-12 text-gray-900 relative" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,249,255) 0%, rgb(224,242,254) 50%, rgb(240,249,255) 100%)'
  }} data-id="element-422">
      <div className="mx-auto max-w-4xl" data-id="element-423">

        {/* Label */}
        <div className="flex items-center justify-center gap-2 mb-2" data-id="element-424">
          <span className="h-px w-8" style={{
          backgroundColor: '#38bdf8'
        }} data-id="element-425" />
          <p className="text-xs sm:text-sm font-bold tracking-[2px] uppercase m-0" style={{
          color: '#0284c7'
        }} data-id="element-426">
            El producto base
          </p>
          <span className="h-px w-8" style={{
          backgroundColor: '#38bdf8'
        }} data-id="element-427" />
        </div>

        {/* Heading */}
        <h2 className="text-2xl sm:text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-428">
          Médico en Proceso™:{' '}
          <span style={{
          color: '#0284c7'
        }} data-id="element-429">Nivel 1</span>
        </h2>

        <p className="text-center text-sm text-gray-500 m-0 mb-2" data-id="element-430">
          6 tomos · 6 bonos · +360 páginas
        </p>

        <p className="text-center text-sm text-gray-600 mx-auto max-w-lg m-0 mb-8" data-id="element-431">
          El contenido central de toda la carrera de Medicina, armado sobre los
          planes de estudio oficiales de UBA, UNLP y UNC.{' '}
          <strong className="text-gray-800" data-id="element-432">
            Sin buscar más. Sin improvisar.
          </strong>
        </p>

        {/* Tomos */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm mb-4" style={{
        border: '1px solid rgba(2,132,199,0.2)'
      }} data-id="element-433">
          <div className="px-5 py-2.5 flex items-center justify-between gap-3" style={{
          background: 'linear-gradient(135deg, #0369a1 0%, #0284c7 100%)'
        }} data-id="element-434">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-435">
              📚 Los 6 Tomos
            </h3>
            <span className="shrink-0 text-[10px] font-bold rounded-full px-2 py-0.5 whitespace-nowrap" style={{
            color: '#bae6fd',
            backgroundColor: 'rgba(2,132,199,0.4)'
          }} data-id="element-436">
              +360 páginas
            </span>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-437">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-3" data-id="element-438">
                <span className="shrink-0 text-xl w-8 text-center" data-id="element-439">
                  {tome.emoji}
                </span>
                <div className="flex-1 min-w-0" data-id="element-440">
                  <span className="block text-xs font-black text-gray-900" data-id="element-441">
                    Tomo {tome.number} — {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-442">
                    {tome.desc}
                  </span>
                </div>
                <div className="shrink-0 w-16 h-12 rounded-lg overflow-hidden" style={{
              border: '1px solid rgba(14,165,233,0.2)'
            }} data-id="element-443">
                  <img src={tome.image} alt={`Tomo ${tome.number}`} className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-444" />
                </div>
              </div>)}
          </div>
        </div>

        {/* Bonos */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm mb-6" style={{
        border: '1px solid rgba(2,132,199,0.2)'
      }} data-id="element-445">
          <div className="px-5 py-2.5 flex items-center justify-between gap-3" style={{
          background: 'linear-gradient(135deg, #0369a1 0%, #0284c7 100%)'
        }} data-id="element-446">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-447">
              🎁 Los 6 Bonos incluidos
            </h3>
            <span className="shrink-0 text-[10px] font-bold rounded-full px-2 py-0.5 whitespace-nowrap" style={{
            color: '#bae6fd',
            backgroundColor: 'rgba(2,132,199,0.4)'
          }} data-id="element-448">
              GRATIS
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 divide-y sm:divide-y-0 divide-gray-100" data-id="element-449">
            {bonuses.map((bonus, i) => <div key={bonus.title} className={`flex items-center gap-3 px-5 py-3 ${i % 2 === 0 ? 'sm:border-r border-gray-100' : ''} ${i < bonuses.length - 2 ? 'sm:border-b border-gray-100' : ''}`} data-id="element-450">
                <span className="text-lg shrink-0" data-id="element-451">{bonus.emoji}</span>
                <span className="text-xs font-semibold text-gray-800" data-id="element-452">
                  {bonus.title}
                </span>
              </div>)}
          </div>
        </div>

        {/* Tags footer */}
        <div className="rounded-xl px-5 py-3 flex flex-wrap gap-2 justify-center" style={{
        backgroundColor: 'rgb(224,242,254)',
        border: '1px solid rgba(14,165,233,0.3)'
      }} data-id="element-453">
          {['📄 100% PDF', '⚡ Acceso inmediato', '🇦🇷 Hecho para Argentina', '🏫 Compatible con UBA · UNC · UNLP y más'].map(tag => <span key={tag} className="text-[11px] font-semibold text-gray-700 bg-white rounded-full px-2.5 py-1" style={{
          border: '1px solid rgba(14,165,233,0.25)'
        }} data-id="element-454">
              {tag}
            </span>)}
        </div>
      </div>

      {/* Separador hacia siguiente sección */}
      <div className="mx-auto max-w-4xl mt-10 flex flex-col items-center gap-2" data-id="element-455">
        <p className="text-xs font-bold uppercase tracking-widest m-0" style={{
        color: '#0284c7'
      }} data-id="element-456">
          ¿Querés más que el contenido?
        </p>
        <p className="text-sm text-gray-600 text-center m-0" data-id="element-457">
          El Sistema Carrera Organizada™ agrega los tomos clínicos de Guardia y
          Medicina Interna para los años más exigentes.
        </p>
        <div className="flex items-center gap-2 mt-1" data-id="element-458">
          <div className="h-px w-16" style={{
          backgroundColor: '#7dd3fc'
        }} data-id="element-459" />
          <span style={{
          color: '#38bdf8'
        }} className="text-lg" data-id="element-460">↓</span>
          <div className="h-px w-16" style={{
          backgroundColor: '#7dd3fc'
        }} data-id="element-461" />
        </div>
      </div>

      {/* Degradé de integración con Bonuses */}
      <div className="absolute bottom-0 left-0 right-0 h-16 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent 0%, rgb(248,251,255) 100%)'
    }} data-id="element-462" />
    </section>;
}